
const useValidation = () => {
  const validation = {
    email: {
      required: 'required field',
      pattern: {
        value: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'Wrong email address format'
      }
    },
    required: {
      required: 'required field'
    },
    phone: {
      required: 'required field',
      pattern: {
        value: /\d{9,12}/,
        message: 'Length must be between 9 and 12'
      }
        
    },
    oneOfThemRequired: (value1) => ({
      validate: (value) => {
        return !value && !value1 ? 'required field' : undefined;
      },
    })
  };

  return validation;
};

export default useValidation;
